import React from 'react';
import { MapChampion } from './mapTypes';
import StaticChampionCard from '../../StaticSandbox/components/StaticChampionCard';
import '../../XXX/GameSimulator/GameContainer2/GameGrid/GameGrid.css';
import './MapChampionCards.css';

interface MapChampionCardsProps {
  champions: MapChampion[];
  onChampionUpdate: (updatedChampion: any) => void;
}

const MapChampionCards: React.FC<MapChampionCardsProps> = ({
  champions,
  onChampionUpdate,
}) => {
  if (champions.length === 0) return null;

  return (
    <div className="map-cards-grid">
      {champions.map((mc, idx) => (
        <div
          key={`card-${mc.champion.id}-${idx}`}
          className="map-card-cell"
          style={{ borderTopColor: mc.color }}
        >
          <StaticChampionCard
            champion={mc.champion}
            regularLogs={[]}
            comboLogs={[]}
            targetChampion={null}
            onSelectTargetClick={() => {}}
            onChampionUpdate={onChampionUpdate}
          />
        </div>
      ))}
    </div>
  );
};

export default MapChampionCards;
